import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    class: "w-full flex flex-col gap-[3.2rem]"
};
const _hoisted_2 = {
    class: "w-full grid tablet:grid-cols-[38.4rem_1fr] gap-[2.4rem]"
};
const _hoisted_3 = {
    class: "w-full grid tablet:grid-cols-[38.4rem_1fr] gap-[3.2rem] tablet:gap-[2.4rem]"
};
const _hoisted_4 = {
    class: "w-full flex flex-col gap-[3.2rem]"
};
const _hoisted_5 = {
    class: "w-full flex flex-col"
};
const _hoisted_6 = {
    class: "w-full flex flex-col gap-[4rem]"
};
const _hoisted_7 = {
    class: "w-full flex flex-col gap-[2.4rem]"
};
const _hoisted_8 = {
    class: "w-full flex flex-col gap-[2.4rem]"
};
const _hoisted_9 = {
    class: "w-full flex items-center justify-center"
};
import Pagination from '../Common/Pagination.vue';
import Search from '../Common/Filters/Serach.vue';
import ServiceTyp from '../Common/Filters/ServiceTyp.vue';
import Sex from '../Common/Filters/Sex.vue';
import ServiceBox from './ServiceBox.vue';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
export default {
    __name: 'Services',
    setup (__props) {
        const store = useStore();
        let services = computed(()=>{
            return store.state.services.services;
        });
        let meta = computed(()=>{
            return store.state.services.meta;
        });
        const state = ref({
            pageSize: 3,
            page: 1,
            loading: false,
            search: '',
            serviceTyp: [],
            sex: []
        });
        const loadServices = async (page = 3)=>{
            // .value is needed in JavaScript
            state.value.loading = true;
            let data = {
                per_page: state.value.pageSize,
                page: page
            };
            if (state.value.search) {
                data['search'] = state.value.search;
            }
            if (state.value.serviceTyp) {
                data['services_typ'] = state.value.serviceTyp;
            }
            if (state.value.sex) {
                data['sex'] = state.value.sex;
            }
            await store.dispatch('GetServices', {
                data: {
                    ...data
                }
            });
            state.value.loading = false;
        };
        loadServices(state.value.page);
        const removeFilters = ()=>{
            state.value.search = ''; // Resetuje filtr wyszukiwania
            state.value.serviceTyp = []; // Resetuje filtr typu usług
            state.value.sex = []; // Resetuje filtr płci
            loadServices(state.value.page); // Ładuje usługi z zresetowanymi filtrami
        };
        return (_ctx, _cache)=>{
            const _directive_loading = _resolveDirective("loading");
            return _openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(Search, {
                        search: state.value.search,
                        "onUpdate:search": _cache[0] || (_cache[0] = ($event)=>state.value.search = $event),
                        loadData: loadServices,
                        pageSize: state.value.pageSize,
                        value: state.value.search
                    }, null, 8, [
                        "search",
                        "pageSize",
                        "value"
                    ])
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                            class: "w-full flex items-center justify-between"
                        }, [
                            _cache[4] || (_cache[4] = _createElementVNode("p", {
                                class: "display-md"
                            }, "Filtry", -1)),
                            _createElementVNode("p", {
                                class: "body-sm text-gray-500 font-semibold cursor-pointer",
                                onClick: removeFilters
                            }, "Wyczyść wszystko")
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(ServiceTyp, {
                                servicesTyp: state.value.serviceTyp,
                                "onUpdate:servicesTyp": _cache[1] || (_cache[1] = ($event)=>state.value.serviceTyp = $event),
                                value: state.value.serviceTyp
                            }, null, 8, [
                                "servicesTyp",
                                "value"
                            ]),
                            _createVNode(Sex, {
                                sex: state.value.sex,
                                "onUpdate:sex": _cache[2] || (_cache[2] = ($event)=>state.value.sex = $event),
                                value: state.value.sex
                            }, null, 8, [
                                "sex",
                                "value"
                            ])
                        ]),
                        _createElementVNode("button", {
                            class: "btn btn--primary !w-full justify-center",
                            onClick: _cache[3] || (_cache[3] = ($event)=>loadServices(state.value.page))
                        }, "Zastosuj")
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(services), (service)=>{
                                return _openBlock(), _createBlock(ServiceBox, {
                                    key: service.id,
                                    service: service
                                }, null, 8, [
                                    "service"
                                ]);
                            }), 128))
                        ])), [
                            [
                                _vShow,
                                _unref(services).length > 0
                            ],
                            [
                                _directive_loading,
                                state.value.loading
                            ]
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, _cache[5] || (_cache[5] = [
                            _createElementVNode("p", {
                                class: "display-md"
                            }, "Brak wyników", -1)
                        ]))), [
                            [
                                _vShow,
                                _unref(services).length === 0
                            ],
                            [
                                _directive_loading,
                                state.value.loading
                            ]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_9, [
                            _createVNode(Pagination, {
                                pageSize: state.value.pageSize,
                                total: Number(_unref(meta).totals),
                                sizeChange: loadServices
                            }, null, 8, [
                                "pageSize",
                                "total"
                            ])
                        ], 512), [
                            [
                                _vShow,
                                Number(_unref(meta).totals) !== 0 && Number(_unref(meta).pages) !== 1
                            ]
                        ])
                    ])
                ])
            ]);
        };
    }
};
